import { render, staticRenderFns } from "./UploadServers.vue?vue&type=template&id=08d3382a&scoped=true&"
import script from "./UploadServers.vue?vue&type=script&lang=js&"
export * from "./UploadServers.vue?vue&type=script&lang=js&"
import style0 from "./UploadServers.vue?vue&type=style&index=0&id=08d3382a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d3382a",
  null
  
)

export default component.exports